import { CONTEXT_PROPS } from '../types/ContextProps';
import { siteIDs } from './utils';
export function experimentEnabled(key, context) {
    var experiments = (context === null || context === void 0 ? void 0 : context[siteIDs.EXPERIMENTS]) ||
        (context === null || context === void 0 ? void 0 : context[CONTEXT_PROPS.EXPERIMENTS]) ||
        {};
    return ['true', 'new', true].includes(experiments[key]);
}
